import store from '@/store';
// 手机品牌
const phone_list = require('@/assets/json/device_brand.json');

/** 定向包-表单配置 */
export {
  audience,
};

const audience = {
  value: {},
  children: {
    // 地域类型
    district: {
      label: '地域类型',
      type: 'radio-group',
      isButton: true,
      options: [
        { label: '不限', value: 'NONE' },
        { label: '按行政区域划分', value: 'REGION' },
      ],
      value: 'NONE',
    },
    // 按行政区域划分
    city: {
      label: ' ',
      name: '地理位置',
      type: 'tree-shuttle',
      hidden: true,
      options: [],
      value: [],
    },
    // 地理位置
    location_type: {
      label: ' ',
      type: 'radio-group',
      hidden: true,
      options: [
        { label: '正在该地区的用户', value: 'CURRENT' },
        { label: '居住在该地区的用户', value: 'HOME' },
        { label: '到该地区旅行的用户', value: 'TRAVEL' },
        { label: '该地区内的所有用户', value: 'ALL' },
      ],
      value: 'CURRENT',
    },
    // 行政区域版本号
    region_version: {
      label: '行政区域版本号',
      type: 'radio-group',
      isButton: true,
      hidden: true,
      options: [],
      value: '',
    },
    // 性别
    gender: {
      label: '性别',
      type: 'radio-group',
      isButton: true,
      options: [
        { label: '不限', value: 'NONE' },
        { label: '男', value: 'GENDER_MALE' },
        { label: '女', value: 'GENDER_FEMALE' },
      ],
      value: 'NONE',
    },
    // 年龄
    age: {
      label: '年龄',
      type: 'checkbox-group',
      isButton: true,
      options: [
        { label: '不限', value: null },
        ...store.getters.jrttEnum['api_age'],
      ],
      value: [null],
    },
    // 自定义人群选项按钮
    crowd_pack_button: {
      label: '自定义人群',
      type: 'radio-group',
      isButton: true,
      hidden: false,
      is_filter: true,
      options: [
        { label: '不限', value: null },
        { label: '自定义', value: 'CUSTOM' },
      ],
      value: null,
    },
    // 人群包
    crowd_pack: {
      label: ' ',
      hidden: true,
      options: [],
      search: '',
      active_name: 'include',
      filtered_value: [],
      tag_filter_list: [],
      value: {
        include: [],
        exclude: [],
      },
    },
    // 行为兴趣
    interest_action_mode: {
      label: '行为兴趣',
      type: 'radio-group',
      isButton: true,
      options: [
        { label: '不限', value: 'UNLIMITED' },
        { label: '系统推荐', value: 'RECOMMEND' },
        { label: '自定义', value: 'CUSTOM' },
      ],
      value: 'UNLIMITED',
      hidden: false,
    },
    // 行为场景
    action_scene: {
      label: '行为场景',
      type: 'select',
      hidden: true,
      options: store.getters.jrttEnum['api_action_scene'],
      value: [],
      props: {
        multiple: true,
      },
    },
    // 用户发生行为天数
    action_days: {
      label: '用户发生行为天数',
      type: 'select',
      hidden: true,
      options: store.getters.jrttEnum['api_action_days'],
      value: null,
    },
    // 行为类目词
    action_categories: {
      label: '行为类目词',
      type: 'tree-shuttle',
      hidden: true,
      options: [],
      props: {
        defaultProps: {
          children: 'children',
          label: 'name',
        },
      },
      value: [],
    },
    // 行为关键词
    action_words: {
      label: '行为关键词',
      type: 'tree-shuttle',
      hidden: true,
      options: [],
      props: {
        defaultProps: {
          children: 'children',
          label: 'name',
        },
      },
      value: [],
    },
    // 兴趣类目词
    interest_categories: {
      label: '兴趣类目词',
      type: 'tree-shuttle',
      hidden: true,
      options: [],
      props: {
        defaultProps: {
          children: 'children',
          label: 'name',
        },
      },
      value: [],
    },
    // 兴趣关键词
    interest_words: {
      label: '兴趣关键词',
      type: 'tree-shuttle',
      hidden: true,
      options: [],
      props: {
        defaultProps: {
          children: 'children',
          label: 'name',
        },
      },
      value: [],
    },
    // 平台
    platform: {
      label: '平台',
      type: 'radio-group',
      isButton: true,
      filter: true,
      disabled: true,
      options: [
        { label: '不限', value: null },
        { label: 'iOS', value: ['IOS'] },
        { label: 'Android', value: ['ANDROID'] },
      ],
      value: ['ANDROID'],
    },
    // 已安装用户
    hide_if_exists: {
      label: '已安装用户',
      type: 'radio-group',
      isButton: true,
      options: [
        { label: '不限', value: 'UNLIMITED', disabled: false },
        { label: '过滤', value: 'FILTER', disabled: false },
        { label: '定向', value: 'TARGETING', disabled: false },
      ],
      value: 'UNLIMITED',
    },
    // 安卓版本
    android_osv: {
      label: '安卓版本',
      type: 'select',
      options: store.getters.jrttEnum['api_android_osv'],
      value: '',
      hidden: false,
    },
    // IOS版本
    ios_osv: {
      label: 'IOS版本',
      type: 'select',
      options: store.getters.jrttEnum['api_ios_osv'],
      value: '',
      hidden: false,
    },
    // 设备类型
    device_type: {
      label: '设备类型',
      type: 'radio-group',
      isButton: true,
      options: [
        { label: '不限', value: null },
        { label: '智能手机', value: ['MOBILE'] },
        { label: '平板', value: ['PAD'] },
      ],
      value: null,
      hidden: false,
    },
    // 网络
    ac: {
      label: '网络',
      type: 'checkbox-group',
      isButton: true,
      options: [
        { label: '不限', value: null },
        ...store.getters.jrttEnum['api_ac'],
      ],
      value: [null],
      hidden: false,
    },
    // 过滤已转化用户
    hide_if_converted: {
      label: '过滤已转化用户',
      type: 'radio-group',
      isButton: true,
      options: store.getters.jrttEnum['api_hide_if_converted'],
      value: 'NO_EXCLUDE',
    },
    // 过滤时间
    converted_time_duration: {
      label: '过滤时间',
      type: 'radio-group',
      isButton: true,
      hidden: true,
      options: store.getters.jrttEnum['api_converted_time_duration'],
      value: 'TODAY',
    },
    device: {
      label: '手机品牌',
      type: 'radio-group',
      isButton: true,
      is_filter: true,
      options: [
        { label: '不限', value: null },
        { label: '按品牌', value: 'CHOOSE_BRAND' },
      ],
      value: null,
      hidden: false,
    },
    // 手机品牌
    device_brand: {
      label: '品牌选择',
      name: '手机品牌',
      type: 'tree-shuttle',
      hidden: true,
      options: phone_list.data,
      value: [],
    },
    // 手机价格
    phone_prices: {
      label: '手机价格',
      type: 'radio-group',
      hidden: false,
      isButton: true,
      is_filter: true,
      options: [
        { label: '不限', value: null },
        { label: '自定义', value: 'CUSTOM' },
      ],
      value: null,
    },
    // 价格
    launch_price: {
      label: ' ',
      type: 'slider',
      hidden: true,
      options: {
        0: '0元',
        2000: '2000元',
        5000: '5000元',
        10000: '1万元',
      },
      props: {
        'show-stops': true,
        range: true,
        max: 11000,
        step: 500,
      },
      quickSetting: function(val){
        this.value = val;
      },
      value: [0, 11000],
    },
    // 智能放量
    auto_extend_enabled: {
      label: '智能放量',
      type: 'radio-group',
      isButton: true,
      is_filter: true,
      options: [
        { label: '不启用', value: 0 },
        { label: '启用', value: 1 },
      ],
      value: 0,
      hidden: false,
    },
    // 可开放定向类型
    auto_extend_targets: {
      label: ' ',
      name: '可开放定向类型',
      type: 'tree-shuttle',
      hidden: true,
      options: store.getters.jrttEnum['api_auto_extend_targets'].map((item) => {
        return {
          label: item.label,
          id: item.value,
        };
      }),
      value: [],
    },
  },
};
